<template>
  <v-container fluid style="padding: 25px">
    <v-row v-if="loading" justify="center" class="mt-10">
      <v-col cols="auto" class="d-flex flex-column align-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="70"
          width="7"
        />
        <p class="mt-4">Chargement des vidéos...</p>
      </v-col>
    </v-row>
    <template v-else>
      <v-row justify="center">
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="search"
            label="Rechercher une vidéo"
            prepend-inner-icon="mdi-magnify"
            clearable
            hide-details
            outlined
            dense
          />
        </v-col>
      </v-row>
      <v-row v-if="!filteredCards.length" justify="center" class="mt-10">
        <p>Aucune vidéo disponible</p>
      </v-row>
      <v-row v-else>
        <v-col
          v-for="card in filteredCards"
          :key="card._id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-card @click="openVideo(card)">
            <v-img
              :src="card.thumbnail"
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="200px"
              cover
            >
            </v-img>
            <v-card-title class="d-flex align-center flex-nowrap">
              <span
                class="flex-grow-1 text-truncate"
                style="min-width: 0"
                v-text="card.name"
              ></span>
              <v-spacer></v-spacer>
              <v-tooltip v-if="currentUser.is_admin" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="d-flex align-center"
                    v-bind="attrs"
                    v-on="on"
                    style="cursor: default"
                  >
                    <span
                      class="mr-1"
                      style="
                        white-space: nowrap;
                        font-weight: normal;
                        font-size: medium;
                      "
                      >{{ card.viewCount || 0 }}</span
                    >
                    <v-icon>mdi-eye</v-icon>
                  </div>
                </template>
                <span>Nombre de vues</span>
              </v-tooltip>
              <v-tooltip v-if="card.leodataPath" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="showInLeodata(card)"
                  >
                    mdi-folder-outline
                  </v-icon>
                </template>
                <span>Afficher dans LeoData</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="openVideo(card)"
                  >
                    mdi-play-circle-outline
                  </v-icon>
                </template>
                <span>Regarder la vidéo</span>
              </v-tooltip>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <v-dialog v-model="dialog" max-width="1200">
      <v-card v-if="selectedVideo">
        <iframe
          style="width: 100%; aspect-ratio: 16 / 9; border: 0; display: block"
          :src="`${selectedVideo.link}?rel=0&modestbranding=1&iv_load_policy=3`"
          title="YouTube video player"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      cards: [],
      search: "",
      loading: false,
      dialog: false,
      selectedVideo: null,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "user/getUser",
    }),
    filteredCards() {
      const search = this.search?.trim().toLowerCase();
      if (!search) return this.cards;
      return this.cards.filter((card) =>
        card.name.toLowerCase().includes(search)
      );
    },
  },
  mounted() {
    this.fetchVideos();
  },
  methods: {
    async fetchVideos() {
      this.loading = true;
      try {
        const videos = await this.$store.dispatch("leodata/getVideos");
        this.cards = videos.map((video) => ({
          ...video,
          thumbnail: this.getThumbnail(video.link),
          leodataPath: null,
        }));
        this.cards.forEach(this.fetchLeodataPath);
      } catch (error) {
        console.error("Erreur lors du chargement des vidéos :", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchLeodataPath(card) {
      try {
        card.leodataPath = await this.$store.dispatch(
          "leodata/getFilePath",
          card._id
        );
      } catch (error) {
        card.leodataPath = null;
      }
    },
    getThumbnail(link) {
      const match = link && link.match(/embed\/([^?&/]+)/);
      const videoId = match ? match[1] : null;
      return videoId
        ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
        : null;
    },
    openVideo(video) {
      this.selectedVideo = video;
      this.dialog = true;
      this.$store
        .dispatch("leodata/getFile", video._id)
        .then((response) => {
          if (this.selectedVideo && this.selectedVideo._id === video._id) {
            this.selectedVideo = response.file;
          }
        })
        .catch(() => {});
    },
    showInLeodata(video) {
      if (!video.leodataPath) return;
      const url = `/leodata/${video.leodataPath
        .slice(1)
        .map((item) => encodeURIComponent(item.name))
        .join("/")}`;
      this.$router.push(url);
    },
  },
};
</script>
